/* eslint-disable */
export default {
  doNotCall: 'Ne pas appeler',
} as const;

// @key: @#@"doNotCall"@#@ @source: @#@"Do Not Call"@#@
